// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "leticia-vaz-dbb93.firebaseapp.com",
  "projectId": "leticia-vaz-dbb93",
  "storageBucket": "leticia-vaz-dbb93.appspot.com",
  "messagingSenderId": "866021653804",
  "appId": "1:866021653804:web:09be2b712f7ca70a020089",
  "measurementId": "G-ZHH0GQEBMC",
  "apiKey": "AIzaSyAFz5cm_Cc0MxFiRt87L4rx8DzuVJ0A3jo"
};
